<template>
  <sdPageHeader :title="$t('pages.application-usage.title')"> </sdPageHeader>

  <Main>
    <sdCards>
      <a-form layout="vertical" :model="form" @submit="handleSubmit">
        <a-row :gutter="16">
          <a-col :span="4">
            <a-form-item :label="$t('pages.application-usage.year')">
              <a-select v-model:value="selectedYear">
                <a-select-option :value="singleYear" v-for="(singleYear, index) in years" :key="index">
                  {{ singleYear }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="4">
            <a-form-item :label="$t('pages.application-usage.month')">
              <a-tree-select
                style="width: 100%"
                v-model:value="form.dates"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :placeholder="$t('pages.application-usage.namespace-month')"
                allow-clear
                multiple
              >
                <a-tree-select-node
                  v-for="(month, index) in months"
                  :key="selectedYear + index"
                  :value="selectedYear + '/' + (index + 1)"
                  :title="selectedYear + '/' + (index + 1)"
                />
              </a-tree-select>
            </a-form-item>
          </a-col>

          <a-col :span="4">
            <a-form-item :label="$t('pages.application-usage.type')">
              <a-select v-model:value="form.type">
                <a-select-option :value="1">
                  {{ $t('pages.application-usage.form') }}
                </a-select-option>
                <a-select-option :value="2">
                  {{ $t('pages.application-usage.widget') }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="4">
            <a-form-item :label="$t('pages.application-usage.label-smallest-value')">
              <a-input v-model:value="form.smallestValue" type="number" :placeholder="$t('pages.application-usage.namespace-smallest-value')" />
            </a-form-item>
          </a-col>

          <a-col :span="4">
              <a-form-item label="&nbsp;">
            <SearchBoxVue v-model:text="form.search" @text-changed="onFilterChanged()" />
            </a-form-item>
          </a-col>

          <a-col :span="4">
            <a-form-item label="&nbsp;">
          <a-button type="primary" html-type="submit"> {{ $t('common.filter') }} </a-button>
        </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <a-row :gutter="25">
        <a-col :sm="24" :xs="24">
          <div v-if="isLoading" class="spin">
            <a-spin />
          </div>
          <div v-else>
            <a-table
              class="table-responsive"
              :columns="columns"
              :data-source="tableContent"
              :pagination="{
                pageSize: this.form.pageSize,
                showSizeChanger: true,
                total: this.form.total,
                current: this.form.current,
              }"
              @change="onTableChange"
              size="small"
            >
            </a-table>
          </div>
        </a-col>
      </a-row>
    </sdCards>
  </Main>
</template>

<script>
import { Main } from '@/view/styled';
import SearchBoxVue from '@/components/search/SearchBox.vue';
import moment from 'moment';


export default {
  name: 'ApplicationUsage',
  components: {
    Main,
    SearchBoxVue,
    moment
  },
  data() {
    return {
      isLoading: true,
      years: [],
      selectedYear: null,
      dateInfo: [],
      tableContent: [],
      isFilterNew: false,
      form: {
        dates: [],
        type: 1,
        current: 1,
        pageSize: 10,
        total: null,
        search: '',
        smallestValue: 0
      },
      columns: [],
      months: [
        this.$t('common.january'),
        this.$t('common.febuary'),
        this.$t('common.march'),
        this.$t('common.april'),
        this.$t('common.may'),
        this.$t('common.june'),
        this.$t('common.july'),
        this.$t('common.august'),
        this.$t('common.september'),
        this.$t('common.october'),
        this.$t('common.november'),
        this.$t('common.december'),
      ],
    };
  },
  created() {
    this.get();
    this.getYears();
    var firstDate = moment().year() + "/" +  (parseInt(moment().month()) + 1);
    this.form.dates.push(firstDate);
  },
  methods: {
    onFilterChanged() {
      this.isFilterNew = true;
    },
    onTableChange(e) {
      this.form.current = this.isFilterNew ? 1 : e.current;
      this.form.pageSize = e.pageSize;
      this.get();
      this.isFilterNew = false;
    },
    handleSubmit() {
      this.get();
    },
    getYears() {
      this.$appAxios
        .post(this.$endpoints.usage_get_years, this.form)
        .then(resp => {
          if (resp.data.status === true) {
            this.years = resp.data.data.years;
            this.selectedYear = this.years[this.years.length - 1];
          } else {
            this.$message.error(this.$t('common.error-message'));
          }
        })
        .catch(e => {
          this.$message.error(this.$t('common.error-message'));
        });
    },
    clearColumns() {
      this.columns = [
        {
          title: this.$t('pages.application-usage.table-apps'),
          dataIndex: 'app',
          key: 'app',
        },
      ];
    },
    createTableHeaders() {
      for (let j = 0; j < this.dateInfo.length; j++) {
        var obj = {
          title: this.months[this.dateInfo[j].month - 1] + ' ' + this.dateInfo[j].year,
          dataIndex: this.dateInfo[j].date,
          key: this.dateInfo[j].date,
        };
        this.columns.push(obj);
      }

      var obj = {
        title: this.$t('pages.application-usage.table-total'),
        dataIndex: 'total',
        key: 'total',
      };
      this.columns.push(obj);
    },
    get() {
      this.isLoading = true;
      this.$appAxios
        .post(this.$endpoints.usage_get, this.form)
        .then(resp => {
          if (resp.data.status === true) {
            this.clearColumns();
            var tableRecords = resp.data.data.tableData || [];
            this.form.total = resp.data.data.total || 0;
            this.dateInfo = resp.data.data.dateInfo || 0;
            this.tableContent = [];

            this.createTableHeaders();

            for (let index = 0; index < tableRecords.length; index++) {
              var obj = {};

              for (let j = 0; j < this.dateInfo.length; j++) {
                obj[this.dateInfo[j].date] = tableRecords[index][this.dateInfo[j].date];
              }
              obj['key'] = tableRecords[index].app_id;
              obj['app'] = tableRecords[index].title;
              obj['total'] = tableRecords[index].total;

              this.tableContent.push(obj);
            }
          } else {
            this.$message.error(resp.data.message);
          }
          this.isLoading = false;
        })
        .catch(e => {
          this.$message.error(this.$t('common.error-message'));
          this.isLoading = false;
        });
    },
  },
};
</script>

<style>
.czKcFK .ant-input {
    padding: 7px 11px;
}

.ant-select-multiple .ant-select-selector::after {
    display: inline-block;
    width: 0;
    margin: 2px 0;
    line-height: 32px;
    content: '\a0';
}
</style>
